import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { setAuth, setRole } from '../Redux/Actions/AuthActions';

/** Sync auth from localStorage after hydration so SSR markup (logged-out) matches the first client render. */
export function AuthHydrationSync() {
    const dispatch = useDispatch();

    useEffect(() => {
        const token = localStorage.getItem('userToken');
        dispatch(setAuth(Boolean(token)));

        const roleId = localStorage.getItem('roleId');
        if (roleId) {
            dispatch(setRole(roleId));
        }
    }, [dispatch]);

    return null;
}
